module.exports = __webpack_public_path__ + "static/media/WI1.6db28f05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/WI/WI1.png
// module id = 736
// module chunks = 0